module.exports = __webpack_public_path__ + "static/ogdefault-547800716fbccb7ce74e70957629e6c1.png";